import axios from "axios";
import createAuthRefreshInterceptor from "axios-auth-refresh";
import refreshToken from "@components/API/refreshToken";
import {API_HOST} from "@constants/ENV";

const REFUND_URL = `https://${API_HOST}/rest/api/v1.2/admin/refunds`;
const ANROK_ONLY_REFUND_URL = `${REFUND_URL}/anrok`;
const REFUND_STATUS_URL = `${REFUND_URL}/status`;
const ACCESS_TOKEN_EXPIRED_CODES = ['ACCESS_TOKEN_EXPIRED', 'AccessTokenExpired', 'access_token_expired'];

export const shouldRefreshRefundRequest = (error) => {
    const status = error.response?.status;
    const errorCode = error.response?.data?.error;

    return status === 401 || (status === 403 && ACCESS_TOKEN_EXPIRED_CODES.includes(errorCode));
};

const instance = axios.create();

createAuthRefreshInterceptor(instance, refreshToken, {
    statusCodes: [401, 403],
    shouldRefresh: shouldRefreshRefundRequest
});

const postRefund = (url, {transactionId, comment}) => instance({
    method: 'post',
    url,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
    },
    data: {
        transactionId,
        comment
    }
}).then(response => response.data);

export const fetchRefundStatus = transactionId => instance({
    method: 'post',
    url: REFUND_STATUS_URL,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
    },
    data: {transactionId}
}).then(response => response.data);

const refundTransaction = request => postRefund(REFUND_URL, request);

export const refundAnrokOnly = request => postRefund(ANROK_ONLY_REFUND_URL, request);

export default refundTransaction;
